import { Overline } from '@cian/ui-kit';

import { type FC } from 'react';

import { middot } from '@/packages/shared-ui/symbols/symbols';

type PublisherTypeProps = {
  labels: Array<string>;
};

export const PublisherType: FC<PublisherTypeProps> = props => {
  const { labels } = props;

  if (!labels.length) {
    return null;
  }

  return (
    <Overline color="gray60_100" whiteSpace="pre">
      {labels.join(`${middot}\n`)}
    </Overline>
  );
};
